/**
 * @readonly
 * @enum {string}
 */
export const FuelTypes = Object.freeze({
    PETROL: 'PETROL',
    DIESEL: 'DIESEL',
    HYBRID_PETROL: 'HYBRID_PETROL',
    HYBRID_DIESEL: 'HYBRID_DIESEL',
    LPG: 'LPG',
    ELECTRIC: 'ELECTRIC',
    LNG: 'LNG',
    CNG: 'CNG',
    HYDROGEN: 'HYDROGEN',
    PHEV: 'PHEV',
    UNKNOWN: 'UNKNOWN'
})
